
import { useStore } from 'vuex';
import { onMounted, watch } from 'vue';
import { useAuth0 } from '@auth0/auth0-vue';
import { datadogRum } from '@datadog/browser-rum';
import EventTracker from '@/utils/EventTracker';

export default {
  setup() {
    const store = useStore();
    const { user } = useAuth0();

    // Identify the logged-in user in Datadog RUM so sessions show the real
    // username/email instead of "Public User". The Auth0 user is restored
    // asynchronously from cache, hence the watcher instead of a one-time read.
    watch(
      user,
      (authUser) => {
        if (authUser) {
          datadogRum.setUser({
            id: authUser.sub,
            name: authUser.name,
            email: authUser.email,
          });
        } else {
          datadogRum.clearUser();
        }
      },
      { immediate: true },
    );

    onMounted(async () => {
      new EventTracker();
      await store.dispatch('setAllCustomers');
      await store.dispatch('setSaleOrderStates');
    });
  },
};
